import React, { ReactNode } from 'react';
import Modal from 'react-modal';
import { ReactComponent as SuccessIcon } from 'assets/icons/success.svg';
import { Link } from 'react-router-dom';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import useDashboardContext from 'contexts/dashboard.context';
type SuccessModalProps = {
  show: boolean;
  children?: ReactNode;
  onClose: () => void;
  linkText?: string;
  onLinkClick?: () => void;
  addons: any;
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',
    backgroundColor: '#fff',
    border: 'none',
    padding: '0px',
    overflow: 'unset'
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(3px)',
    zIndex: 10000
  }
};
export function CreateAddonCategoryModal({ show, onClose, addons }: SuccessModalProps) {
  const { routePrefix } = useDashboardContext();
  return (
    <Modal isOpen={show} onRequestClose={onClose} style={customStyles} ariaHideApp={false}>
      <div className='px-12 py-4'>
        <div className='flex justify-center pb-2 '>
          <SuccessIcon className='h-28 w-20' />
        </div>
        <div className='w-64 text-center pb-4 font-semibold leading-6 '>
          New add-on category has been successfully added
        </div>
      </div>
      <Link
        to={`${routePrefix}/${ROUTE_KEYS.NEW_ADDON}/${ROUTE_KEYS.NEW_ADDON_DETAILS}`}
        onClick={() =>
          localStorage.setItem(STORAGE_KEYS.NEW_ADDON_CATEGORY, JSON.stringify(addons))
        }
        className='flex justify-center bg-[#F8F6F7] text-[#E60A2B] text-xs font-[500] tracking-wider py-5 border-b rounded-[10px] border-transparent'>
        <p className='uppercase font-medium'>PROCEED TO ADD ADD-ONS</p>
      </Link>
    </Modal>
  );
}
